import { render, staticRenderFns } from "./DettaglioEvento.vue?vue&type=template&id=09b69227&"
import script from "./DettaglioEvento.vue?vue&type=script&lang=js&"
export * from "./DettaglioEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports